import type { ReactNode } from "react";
import { PureComponent } from "react";
import styled from "styled-components";

export interface IFilter {
    id: string;
    filter: ReactNode;
}

interface IFiltersBarProps {
    filters: IFilter[];
}

const FiltersContainerStyle = styled.div`
    display: flex;
    align-items: center;
`;

export class FiltersBar extends PureComponent<IFiltersBarProps> {
    public constructor(props) {
        super(props);
    }

    public render() {
        const { filters } = this.props;
        return (
            <FiltersContainerStyle className="FiltersContainer">
                {filters.map((filter) => {
                    return <div key={filter.id}>{filter.filter}</div>;
                })}
            </FiltersContainerStyle>
        );
    }
}
